'use client'
import { SubItemList } from '@/app/ui/parts/default/sp/itemlist/sub/itemlist'
import { queryType } from '@/lib/api/query'
import { getItems, itemType, paginationType } from '@/lib/item/server'
import { serviceType } from '@/lib/service/server'
import Link from 'next/link'
import { useEffect, useState } from 'react'

type ItemListProps = {
  service: serviceType
  query: queryType
  slider: boolean
}

export const SaleItemListClientComponent: React.FC<ItemListProps> = ({
  service,
  query,
  slider,
}) => {
  query.sale = true
  //   const data = await getItems(service.service_id, query)
  const [data, setData] = useState<{
    items: itemType[]
    pagination: paginationType
  } | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      const result = await getItems(service.service_id, query)
      setData(result)
    }
    fetchData().catch((error) => {
      console.error('Error fetching sale items:', error)
    })
  }, [service.service_id, query])
  if (!data) {
    return <div></div>
  }
  return (
    <div>
      <SubItemList items={data.items} service={service} slider={slider} />
      {query.count < 15 && (
        <div className="item-list-bottom text-center mt-4 mb-4">
          <Link href={`/sale`}>
            <button className="item-list-bottom-button bg-[#fafafa] relative py-3 px-8 text-sm rounded-lg border-[#dddddd] border">
              セール商品の一覧へ
              <span
                className="item-list-bottom-arrow absolute text-lg font-light"
                style={{ color: '#555353', top: '4px', right: '7px' }}
              >
                {' › '}
              </span>
            </button>
          </Link>
        </div>
      )}
    </div>
  )
}
